import {GqlModel, GqlModelOperator, GqlQueryModel} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {toList, toString} from "../helpers/helpers";

export class CDFPreviewGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<CDFPreviewGqlModel> = GqlModel.buildMapper(CDFPreviewGqlModel, "cdfPreview");

  static query: any = gql`
query getCdfPreview($dealId: ID!) {
  cdfPreview: cdfPreview(dealId: $dealId) {
    buildings
  }
}
  `;

  buildings: string[];

  static variables(dealId: string) {
    return {dealId};
  }

  constructor(data: any) {
    super(data);
    data = data || {};

    this.buildings = toList(toString, data.buildings);
  }
}
